import { Box, Container } from "@mui/material";
import { DashboardHeader } from "@components/ui/dashboard/header";
import JobList from "@pages/dashboard/JobList";
import JobStatsGridWrapper from "@pages/dashboard/JobStatsGrid";

const MAIN_DARK_BG = "#0b0f17"; // Fond global sombre identique à la 2ème maquette

const DashboardPage = () => {
  return (
    <Box
      sx={{
        backgroundColor: MAIN_DARK_BG,
        minHeight: "100vh",
        width: "100%",
        color: "#ffffff",
      }}
    >
      <Container disableGutters>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <DashboardHeader />
          <JobStatsGridWrapper />
          <JobList />
        </Box>
      </Container>
    </Box>
  );
};

export default DashboardPage;